import { useEffect } from 'react';
import { useSimulation } from '../context/SimulationContext';
import { WS_EVENTS } from '../types/simulation.types';

/**
 * Handles automatic reconnection and state rebuild.
 * When the socket reconnects, it emits RECONNECT to request a STATE_SNAPSHOT
 * from the server. The STATE_SNAPSHOT handler in the reducer rebuilds the UI.
 *
 * Socket.io's built-in reconnection handles the transport layer.
 * The io.on('reconnect') handler in useSimulationSocket emits the RECONNECT event.
 * This hook monitors reconnection state for UI feedback.
 */
export function useReconnection() {
  const { isReconnecting, isConnected, simSessionId, socketRef } =
    useSimulation();

  useEffect(() => {
    // When we've reconnected but haven't yet received STATE_SNAPSHOT
    if (isConnected && isReconnecting && simSessionId && socketRef.current) {
      socketRef.current.emit(WS_EVENTS.RECONNECT, { simSessionId });
    }
  }, [isConnected, isReconnecting, simSessionId, socketRef]);
}
